import React, { useRef } from 'react';

import { Media } from '$partials/media';
import { Header } from '$partials/global';
import { ModuleDispatcher } from '$partials/modules';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').AboutPage}
 */
const AboutPage = (props) => {
    const page = props.data.page;
    const section1Images = page.images?.slice(0, 3);
    const section2Images = page.images?.length > 2 ? page.images.slice(3) : [];
    const bodyRef = useRef();

    return (
        <>
            <Header
                {...props.data?.header}
                bodyRef={bodyRef}
                domain={props.domain}/>
            <main
                id='main-content'
                ref={bodyRef}>
                <div className='px-layout-outer bg-white relative z-10'>
                    <div className='-mx-layout-col flex flex-wrap'>
                        <div className={`w-full sm:w-3/7 flex-shrink-0 grid gap-y-32 sm:gap-y-42 sm:sticky top-0 pt-[50px] sm:pt-[100px] h-full pb-32 ${section2Images.length === 0 ? 'pb-32': ''}`}>
                            <div className='px-layout-col sm:pr-[170px]'>
                                <h1 className='pb-16'>
                                    {page.title}
                                </h1>
                                <div
                                    className='rich-text max-w-[400px]'
                                    dangerouslySetInnerHTML={{__html: page.standfirst}} />
                            </div>
                            {page.section1?.length > 0 && page.section1.map((section, i) => {
                                return (
                                    <ModuleDispatcher
                                        {...section}
                                        key={i + section?.id}/>
                                );
                            })}

                            {/* Desktop */}
                            {section2Images?.length === 0 && page.section2?.length > 0 && page.section2.map((section, i) => {
                                return (
                                    <ModuleDispatcher
                                        {...section}
                                        key={i + section?.id}/>
                                );
                            })}

                            {/* Mobile */}
                            {page.section2?.length > 0 && (
                                <div className='sm:hidden'>
                                    {page.section2.map(section => {
                                        return (
                                            <div
                                                className='gap-y-16 grid'
                                                key={section.id}>
                                                <div className='w-full flex '>
                                                    <div className='px-layout-col w-1/2 sm:w-1/3'>
                                                        <p>{section.heading1}</p>
                                                    </div>
                                                    <div className='px-layout-col w-1/2 sm:w-1/3'>
                                                        <p>{section.heading2}</p>
                                                    </div>
                                                </div>
                                                <div className='w-full flex'>
                                                    <div
                                                        className='px-layout-col w-1/2 sm:w-1/3'
                                                        dangerouslySetInnerHTML={{__html: section.textCol1}}/>
                                                    <div
                                                        className='px-layout-col w-1/2 sm:w-1/3'
                                                        dangerouslySetInnerHTML={{__html: section.textCol2}}/>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {page.images?.length > 0 && (
                                <div className='sm:hidden -mx-layout-col'>
                                    {page.images.map(itm => {
                                        return (
                                            <div key={itm.media.id}>
                                                <Media {...itm.media}/>
                                            </div>
                                        );
                                    })}
                                </div>
                            )}
                        </div>

                        {/* Desktop sticky images */}
                        <div className='hidden sm:block pl-layout-col -mr-layout-col w-4/7'>
                            {section1Images.length > 0 && section1Images.map(itm => {
                                return (
                                    <div key={itm.media.id}>
                                        <Media {...itm.media}/>
                                    </div>
                                );
                            })}
                        </div>
                    </div>

                    {section2Images.length > 0 && (
                        <div className='-mx-layout-col hidden sm:flex flex-wrap'>
                            <div className='w-full sm:w-3/7 flex-shrink-0 grid gap-y-42 sm:sticky top-0 pt-42 h-full pb-32'>
                                {page.section2?.length > 0 && page.section2.map((section, i) => {
                                    return (
                                        <ModuleDispatcher
                                            {...section}
                                            key={i + section?.id}/>
                                    );
                                })}
                            </div>
                            <div className='pl-layout-col -mr-layout-col w-4/7'>
                                {section2Images?.length > 0 && section2Images.map(itm => {
                                    return (
                                        <div key={itm.media.id}>
                                            <Media {...itm.media}/>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>
                    )}
                </div>
            </main>
        </>
    );
};

/* ========================================================================= */
/* Exports */
/* ========================================================================= */

export default AboutPage;
